import { getCurrentChainId } from 'gql';
import { getOnePieceServerApi } from 'gql-ops';
import { ChainId, DefaultChainId, RPC } from '../constant';
import { action, makeAutoObservable, runInAction, reaction } from 'mobx';
import Web3 from 'web3';
import { User as OpsUser, UserGecStatsV2, RankingResult as UserRank } from 'gql-ops/graph/__generated__/request';
import missionStore from './missionStore';

export class User {
    isOpenConnectModal: boolean = false;
    isDark: boolean = false;
    web3: any;
    address: string = '';
    chainId: ChainId = getCurrentChainId();
    connected: boolean = false;

    opsUserFetched: boolean = false;
    opsUser: OpsUser | undefined;
    userRank: UserRank | undefined;
    private refreshTimeout: ReturnType<typeof setTimeout> | null = null;

    constructor() {
        makeAutoObservable<this>(this);
        reaction(
            () => this.address,
            (address) => {
                if (address) {
                    // Clear any existing timeout
                    if (this.refreshTimeout) {
                        clearTimeout(this.refreshTimeout);
                    }
                    // Set a new timeout to debounce the API calls
                    this.refreshTimeout = setTimeout(async () => {
                        this.refreshOpsUserInfo();
                    }, 300); // 300ms debounce
                } else {
                    runInAction(() => {
                        this.setOpsUserInfo(undefined);
                        this.opsUserFetched = false;
                    });
                }
            },
            { fireImmediately: true },
        );
    }

    toggleConnectModal = () => {
        this.isOpenConnectModal = !this.isOpenConnectModal;
    };

    toggleTheme = () => {
        this.isDark = !this.isDark;
    };

    setWeb3 = (web3: any) => {
        this.web3 = web3;
    };

    @action
    setAddress = (address: string) => {
        this.address = address;
    };

    setConnected = (connected: boolean) => {
        this.connected = connected;
    };
    setChainId = (chainId: ChainId) => {
        this.chainId = chainId;
    };

    clearLoginInfo = () => {
        this.web3 = new Web3(new Web3.providers.HttpProvider(RPC[DefaultChainId]));
        this.chainId = DefaultChainId;
        this.address = '';
        this.connected = false;
    };

    getOpsUserInfo = async () => {
        const res = await getOnePieceServerApi(true).user({
            address: this.address,
        });
        return res;
    };

    setOpsUserInfo = (opsUser?: OpsUser) => {
        this.opsUser = opsUser;
    };

    getUserRank = async () => {
        const res = await getOnePieceServerApi(true).userRank({
            address: this.address,
            type: 'invite',
        });

        return res;
    };

    setUserRank = (rank: UserRank) => {
        this.userRank = rank;
    };

    refreshOpsUserInfo = async () => {
        try {
            const res = await this.getOpsUserInfo();
            const rankRes = await this.getUserRank();
            runInAction(() => {
                this.setOpsUserInfo(res?.user as OpsUser);
                this.setUserRank(rankRes?.userRank as UserRank);
                missionStore.fetchMissions();
                this.opsUserFetched = true;
            });
        } catch (error) {
            // auth fail
            runInAction(() => {
                // this.setUserInfo([], undefined);
                this.setOpsUserInfo(undefined);
                this.opsUserFetched = false;
            });
        }
    };

    getUserGECStatsV2 = async () => {
        if (!this.address) return;
        try {
            const { userGECStatsV2 } = await getOnePieceServerApi().UserGECStatsV2({
                address: this.address,
            });
            return userGECStatsV2 as UserGecStatsV2;
        } catch (error) {
            console.error('Failed to fetch GEC stats v2:', error);
        }
    };
}

export default new User();
